interface NumberedListProps {
  prefix: string;
  items: string[];
}

export const NumberedList = ({ prefix, items }: NumberedListProps) => (
  <ol className="space-y-3">
    {items.map((item, index) => (
      <li key={item} className="flex gap-3">
        <span className="shrink-0 font-semibold text-foreground">
          {prefix}.{index + 1}
        </span>
        <p className="flex-1">{item}</p>
      </li>
    ))}
  </ol>
);
